

export const radioOptions = {
  all: 'all',
  period: 'period'
}
